import { request } from '@/shared/api/request'

export const getDictValues = () => {
	return request({ url: `paryz/dict/dictValues`, method: 'get'})
}

export const getDictValue = (data) => {
	return request({ url: `paryz/dict/dictValues/${data}`, method: 'get' })
}

export const getDictNominations = () => {
	return request({ url: `paryz/dict/nominations`, method: 'get' })
}

export const getDictParams = (data) => {
	return request({ url: `paryz/dict/params`, method: 'get', params: data })
}